import React from "react";
import { Button, Modal } from "react-bootstrap";
import { setModal } from "store/slices/modal";
import { useSelector, useDispatch } from "react-redux";

const SiteModal = () => {
  const state = useSelector((state) => state.modal);
  const dispatch = useDispatch();

  return (
    <>
      <Modal
        show={state.show}
        onHide={() => {
          dispatch(setModal({ ...state, show: false }));
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ textAlign: "right", width: "100%" }}>
            {state.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          dangerouslySetInnerHTML={{
            __html: state.body,
          }}
        ></Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              dispatch(setModal({ ...state, show: false }));
            }}
          >
            بستن
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default SiteModal;
